import React from "react";
import { useGlobal } from "reactn";
import ReactTooltip from "react-tooltip";
import "./CustomerContactEmail.css";

export default function CustomerContactEmail() {
  const [account] = useGlobal("dsUser");
  const [profile, setProfile] = useGlobal("organizationInfo");
  if (account?.accountType !== "Partner" || account.sub_user !== false) return null;
  const available = Object.prototype.hasOwnProperty.call(profile || {}, "customer_contact_email");

  return <div className="customer-contact-email">
    <div className="row">
      <div className="col-5">
        <h3>
          <label htmlFor="customer-contact-email">Customer contact email</label>{" "}
          <button type="button" className="customer-contact-email-info" aria-label="About customer contact email"
            data-tip data-for="customer-contact-email-help"
            onFocus={event => ReactTooltip.show(event.currentTarget)}
            onBlur={event => ReactTooltip.hide(event.currentTarget)}>i</button>
        </h3>
      </div>
      <div className="col-7 d-flex">
        <div className="w-100">
          <input id="customer-contact-email" name="customer_contact_email" type="email" maxLength={254}
            value={profile?.customer_contact_email || ""}
            placeholder="e.g. info@yourorganization.com" autoComplete="email"
            aria-describedby="customer-contact-email-help" disabled={!available}
            onChange={event => setProfile({ ...profile, customer_contact_email: event.target.value })} />
          {!available && <p role="alert" className="customer-contact-email-error">This setting will be available when the system update is complete.</p>}
        </div>
      </div>
    </div>
    <ReactTooltip id="customer-contact-email-help" className="customer-contact-email-tooltip" place="top" effect="solid" type="info">
      Customers will see this address in emails and can reply to it. Leave blank to use your main account email.
    </ReactTooltip>
  </div>;
}
